import { render } from "./ReceivedReplay.vue?vue&type=template&id=558d2fc5&scoped=true"
import script from "./ReceivedReplay.vue?vue&type=script&lang=js"
export * from "./ReceivedReplay.vue?vue&type=script&lang=js"

import "./ReceivedReplay.vue?vue&type=style&index=0&id=558d2fc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558d2fc5"]])

export default __exports__